<template>
  <div class="relative text-base mx-auto lg:max-w-none mb-10">
    <figure>
      <div class="w-full aspect-w-16 aspect-h-10 rounded-md">
        <img
          :src="src"
          :srcset="srcset"
          :alt="alt"
          class="w-full object-cover rounded-md"
        >
      </div>
      <figcaption
        v-if="post.photo_credit_title || post.photo_credit_url"
        class="mt-3 flex items-center text-sm text-neutral-500 space-x-2"
      >
        <svg
          class="flex-none w-5 h-5 text-neutral-300"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z"
            clip-rule="evenodd"
          />
        </svg>
        <span v-if="post.photo_credit_url">
          {{ $t('app.photo-by') }}
          <a
            :href="post.photo_credit_url"
            target="_blank"
            rel="noopener noreferrer nofollow"
            class="hover:underline"
          >
            {{ post.photo_credit_title ?? post.photo_credit_url }}
          </a>
        </span>
        <span v-else-if="post.photo_credit_title">{{ $t('app.photo-by') }} {{ post.photo_credit_title }}</span>
      </figcaption>
    </figure>
  </div>
</template>

<script>
import map from 'lodash/map';

export default {
  name: 'VetsterPostCover',

  props: {
    post: {
      type: Object,
      required: true,
    },
  },

  computed: {
    alt() {
      return this.post.cover.alt;
    },
    src() {
      return this.post.cover.src;
    },
    srcset() {
      return map(this.post.cover.srcset, (url, size) => `${url} ${size}`).join(',');
    },
  },
};
</script>
